<template>
  <div class="filter-box">
    <v-expansion-panels :value="open" @change="changeOpen">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="collapsable-header">
            <div class="bold">Vorbereitungszeit</div>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="collapsable-inner">
            <div class="filter-content">
              <v-checkbox
                v-model="prep"
                value="1"
                label="Ja"
                color="#33bbff"
                @change="output()"
                hide-details
              ></v-checkbox>

              <v-checkbox
                v-model="prep"
                value="0"
                label="Nein"
                color="#33bbff"
                @change="output()"
                hide-details
              ></v-checkbox>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  props: ["filters", 'open'],
  data() {
    return {
      no: true,
      yes: false,
      prep: null,
    };
  },
  watch: {},
  methods: {
    changeOpen(val){
      this.$emit('open', val);
    },
    output() {
      if (this.prep == "1") {
        this.$emit("input", 1);
      } else if (this.prep == "0") {
        this.$emit("input", 0);
      } else {
        this.$emit("input", null);
      }
    },
  },
  mounted() {
    // this.category = JSON.parse(this.category);
    console.log("mounted filters");
  },
  created() {
    // console.log(JSON.parse(this.category));
  },
  computed: {},
};
</script>

<style>
</style>
